<div class="loader" [style.font-size.px]="fontSize"></div>
